import { Box, Text } from '@mantine/core'
import { ReactNode } from 'react'

interface InfoTooltipProps {
  title: ReactNode
  content: ReactNode
  tooltip?: ReactNode
  titleProps?: React.ComponentProps<typeof Text>
  contentProps?: React.ComponentProps<typeof Text>
}

export default function InfoTooltip({
  title,
  content,
  titleProps,
  contentProps,
}: InfoTooltipProps) {
  return (
    <Box>
      <Text
        variant="body"
        mb={4}
        w="fit-content"
        c="var(--text-secondary)"
        display="block"
        {...titleProps}
      >
        {title}
      </Text>

      {typeof content === 'string' ? (
        <Text variant="body1" style={{ display: 'inline-block' }} {...contentProps}>
          {content}
        </Text>
      ) : (
        <Box>{content}</Box>
      )}
    </Box>
  )
}
